module.exports = __webpack_public_path__ + "img/6dfa6bd.png";